export default "<i class=\"la la-spinner la-spin\" [ngStyle]=\"{fontSize: size + 'px'}\"></i>\n"